import React from "react";
import styled from "styled-components";

import PropTypes from "prop-types";

const EntryWrapper = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;

  img {
    width: 100%;
  }

  .contents {
    flex-grow: 1;
  }

  .overflow {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .content {
    display: flex;
    justify-content: space-between;
  }

  .title {
    font-weight: bold;
    font-size: large;
  }

  .content {
    font-weight: 350;
    font-size: small;
  }
`;

export default function VideoListEntry({ video }) {
  return (
    <EntryWrapper>
      <div>
        <img src={video.snippet.thumbnails.high.url} alt="" />
      </div>
      <div className="contents">
        <div className="title">{video.snippet.title}</div>
        <div className="overflow content">{video.snippet.description}</div>
        <div className="content">{video.snippet.publishedAt.substr(0, 10)}</div>
      </div>
    </EntryWrapper>
  );
}

VideoListEntry.propTypes = {
  video: PropTypes.object.isRequired,
};
